<div class="checkerboard h-6 w-6 rounded-sm">
  <div
    class="h-6 w-6 rounded-sm"
    [style.backgroundColor]="selectedColour()"
    [class.cursor-pointer]="!disabled()"
    [class.cursor-not-allowed]="disabled()"
    [matMenuTriggerFor]="disabled() ? undefined : colourPicker"
  ></div>
</div>

<mat-menu #colourPicker (closed)="save()">
  <div class="p-4">
    <pt-colour-selector
      [colour]="colour()"
      [palette]="palette()"
      [enableCustomInput]="enableCustomInput()"
      [disableOpacity]="disableOpacity()"
      [opacityMin]="opacityMin()"
      (colourChange)="selectedColour.set($event)"
    />
  </div>
</mat-menu>
